import { render } from "./CreateV3.vue?vue&type=template&id=2b19792e&scoped=true"
import script from "./CreateV3.vue?vue&type=script&lang=js"
export * from "./CreateV3.vue?vue&type=script&lang=js"

import "./CreateV3.vue?vue&type=style&index=0&id=2b19792e&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b19792e"]])

export default __exports__